import { Component } from "react";
import CriticalErrorPage from "./CriticalErrorPage";
import posthogAnalytics from "@/lib/posthog";

export default class GlobalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error in development
    if (import.meta.env.DEV) {
      console.error("GlobalErrorBoundary caught an error:", error, errorInfo);
    }

    // Track critical error in PostHog
    try {
      posthogAnalytics.track("error_caught_by_boundary", {
        error_type: "critical_error",
        error_boundary: "GlobalErrorBoundary",
        error_message: error?.message || "Unknown critical error",
        error_name: error?.name || "Error",
        error_stack: error?.stack?.substring(0, 500) || "", // Limit stack trace length
        component_stack: errorInfo?.componentStack?.substring(0, 500) || "",
        page:
          typeof window !== "undefined" ? window.location.pathname : "unknown",
        url: typeof window !== "undefined" ? window.location.href : "unknown",
        user_agent:
          typeof navigator !== "undefined" ? navigator.userAgent : "unknown",
        severity: "critical",
      });
    } catch (trackingError) {
      console.error(
        "Failed to track critical error in PostHog:",
        trackingError
      );
    }
  }

  render() {
    if (this.state.hasError) {
      return <CriticalErrorPage error={this.state.error} />;
    }

    return this.props.children;
  }
}
